module.exports = __webpack_public_path__ + "static/media/reverse-fullscreen-square.ea4d0e26.svg";